<app-landing-page-2 *ngIf="showFlygets"></app-landing-page-2>
<div *ngIf="showParkifly">
  <!-- Desktop View -->
  <div class="desktop-view">
    <div class="split-container">
      <div class="left-section">
        <div class="content-wrapper">
          <h1 class="welcome-title text-white">{{ 'LOGIN.WELCOME' | transloco }}</h1>
          <p class="welcome-subtitle">{{ 'PARKIFLY.HOME.CHOOSE_OPTION' | transloco }}</p>

          <div class="stations-list">
            <div *ngFor="let station of parkingOperators" class="station-group">
              <div (click)="continueBooking(station)" class="station-card">
                <div class="station-logo">
                  <img *ngIf="station.name?.en == 'Arlanda Airport'"
                    [src]="station.parkingOperators[0].organizationLogoUrl" alt="Arlanda" />
                  <img *ngIf="station.name?.en == 'Stockholm Skavsta Airport'"
                    [src]="station.parkingOperators[0].organizationLogoUrl" alt="Skavsta" />
                </div>
                <div class="station-info">
                  <h4>{{ station.name[locale] || station.name?.en }}</h4>
                  <p>{{ station.parkingDescription[locale] || station.parkingDescription?.en }}</p>
                </div>
                <div class="station-arrow">
                  <mat-icon>chevron_right</mat-icon>
                </div>
              </div>
            </div>

            <!-- Arlanda booking button -->
            <!-- <div (click)="goToArlandaLandingPage()" class="station-card">
              <div class="station-logo padding-05">
                <img src="../../../assets/img/Aiden-hotel-logo.svg" alt="Aiden" />
              </div>
              <div class="station-info">
                <h4>{{ 'Aiden Hotel Arlanda Parkering' }}</h4>
                <p>{{ 'LOGIN.BOOK_WITH_AIDEN' | transloco }}</p>
              </div>
              <div class="station-arrow">
                <mat-icon>chevron_right</mat-icon>
              </div>
            </div> -->

            <ng-container *ngFor="let station of parkingOperators">
              <div *ngIf="station.driveIn" (click)="goToDriveIn()" class="station-card">
                <div class="station-logo">
                  <img src="../../../assets/img/ParkiFly-logo.svg" alt="PARKIFLY" />
                </div>
                <div class="station-info">
                  <h4>{{ 'DRIVE_IN_BOOKING.DRIVE-IN_PARKING' | transloco }}</h4>
                  <p>{{ 'DRIVE_IN_BOOKING.CONTINUE_DRIVE_IN' | transloco }}</p>
                </div>
                <div class="station-arrow">
                  <mat-icon>chevron_right</mat-icon>
                </div>
              </div>
            </ng-container>

          </div>
        </div>
      </div>

      <div class="right-section">
        <div class="login-wrapper">
          <mat-card [formGroup]="handleBookingGroup">
            <mat-card-header>
              <h3
                class="heading-large-center">
                {{
                'PARKIFLY.HOME.MANAGE_BOOKING' | transloco }}</h3>
            </mat-card-header>
            <mat-card-content class="mt-3">
              <mat-form-field appearance="outline" class="width-100">
                <mat-label>Email</mat-label>
                <input matInput placeholder="Email" formControlName="email">
              </mat-form-field>
              <br>
              <mat-form-field appearance="outline" class="width-100">
                <mat-label>{{ 'PARKIFLY.MANAGE_BOOKING.ORDER_NUMBER' | transloco }}</mat-label>
                <input matInput placeholder="{{ 'PARKIFLY.MANAGE_BOOKING.ORDER_NUMBER' | transloco }}"
                  formControlName="bookingNumber">
              </mat-form-field>
              <button mat-raised-button color="primary" class="mt-2"
                class="btn-full-height-50" (click)="goToHandleBookingForm()">
                {{ 'PARKIFLY.MANAGE_BOOKING.SEARCH' | transloco }}
              </button>
              <p class="text-center-mt-1">
                {{'LOGIN.ORDERS' | transloco}} <a (click)="openLoginDialog()"
                  class="link-primary-underline">{{
                  'DRIVE_IN_BOOKING.INFO_MSG' | transloco }}</a>
              </p>
            </mat-card-content>
          </mat-card>
        </div>
      </div>
    </div>
  </div>

  <!-- Mobile View -->
  <div class="mobile-view">
    <div class="mobile-layout-container">

      <!-- Top Scrollable Content Section -->
      <div class="mobile-top-content">
        <div class="mobile-header">
          <h1 class="welcome-title">{{ 'LOGIN.WELCOME' | transloco }}</h1>
          <p class="welcome-subtitle">{{ 'PARKIFLY.HOME.CHOOSE_OPTION' | transloco }}</p>
        </div>

        <div class="mobile-stations-list">
          <div *ngFor="let station of parkingOperators" class="mobile-station-group">

            <!-- Operator Card (Arlanda / Skavsta) -->
            <div (click)="continueBooking(station)" class="mobile-station-card">
              <div class="mobile-card-logo">
                <img *ngIf="station.name?.en == 'Arlanda Airport'"
                  [src]="station.parkingOperators[0].organizationLogoUrl" alt="Arlanda" />
                <img *ngIf="station.name?.en == 'Stockholm Skavsta Airport'"
                  [src]="station.parkingOperators[0].organizationLogoUrl" alt="Skavsta" />
              </div>
              <div class="mobile-card-info">
                <h4>{{ station.name[locale] || station.name?.en }}</h4>
                <p>{{ station.parkingDescription[locale] || station.parkingDescription?.en }}</p>
              </div>
              <div class="mobile-card-arrow">
                <mat-icon>chevron_right</mat-icon>
              </div>
            </div>
          </div>

          <!-- Aiden Hotel Booking Card -->
          <!-- <div (click)="goToArlandaLandingPage()" class="mobile-station-card">
            <div class="mobile-card-logo padding-025">
              <img src="../../../assets/img/Aiden-hotel-logo.svg" alt="Aiden" />
            </div>
            <div class="mobile-card-info">
              <h4>Aiden Hotel Arlanda Parking</h4>
              <p>{{ 'LOGIN.BOOK_WITH_AIDEN' | transloco }}</p>
            </div>
            <div class="mobile-card-arrow">
              <mat-icon>chevron_right</mat-icon>
            </div>
          </div> -->

          <ng-container *ngFor="let station of parkingOperators">
            <!-- Drive-in Card -->
            <div *ngIf="station.driveIn" (click)="goToDriveIn()" class="mobile-station-card">
              <div class="mobile-card-logo">
                <img src="../../../assets/img/ParkiFly-logo.svg" alt="PARKIFLY" />
              </div>
              <div class="mobile-card-info">
                <h4>{{ 'DRIVE_IN_BOOKING.DRIVE-IN_PARKING' | transloco }}</h4>
                <p>{{ 'DRIVE_IN_BOOKING.CONTINUE_DRIVE_IN' | transloco }}</p>
              </div>
              <div class="mobile-card-arrow">
                <mat-icon>chevron_right</mat-icon>
              </div>
            </div>
          </ng-container>

          <!-- Manage Booking Button -->
          <div class="mobile-manage-booking-wrapper">
            <button mat-raised-button color="primary" class="mobile-manage-booking-btn"
              (click)="openManageBookingModal(manageBookingDialog)">
              <mat-icon class="btn-icon">confirmation_number</mat-icon>
              <span>{{ 'PARKIFLY.HOME.MANAGE_BOOKING' | transloco }}</span>
            </button>
          </div>

        </div>
      </div>

    </div>
  </div>
</div>

<!-- Modal Dialog Template for Manage Booking -->
<ng-template #manageBookingDialog>
  <div class="manage-booking-dialog-container">
    <div class="dialog-header">
      <h3 class="dialog-title">{{ 'PARKIFLY.HOME.MANAGE_BOOKING' | transloco }}</h3>
      <button mat-icon-button class="dialog-close-btn" (click)="closeManageBookingModal()">
        <mat-icon>close</mat-icon>
      </button>
    </div>

    <div class="dialog-body" [formGroup]="handleBookingGroup">
      <mat-form-field appearance="outline" class="dialog-form-field">
        <mat-label>Email</mat-label>
        <input matInput placeholder="Email" formControlName="email">
      </mat-form-field>

      <mat-form-field appearance="outline" class="dialog-form-field">
        <mat-label>{{ 'PARKIFLY.MANAGE_BOOKING.ORDER_NUMBER' | transloco }}</mat-label>
        <input matInput placeholder="{{ 'PARKIFLY.MANAGE_BOOKING.ORDER_NUMBER' | transloco }}"
          formControlName="bookingNumber">
      </mat-form-field>

      <button mat-raised-button color="primary" class="dialog-search-button" (click)="goToHandleBookingForm()">
        {{ 'PARKIFLY.MANAGE_BOOKING.SEARCH' | transloco }}
      </button>

      <p class="dialog-footer-text">
        {{'LOGIN.ORDERS' | transloco}} <a (click)="openLoginDialogFromModal()">{{ 'DRIVE_IN_BOOKING.INFO_MSG' |
          transloco }}</a>
      </p>
    </div>
  </div>
</ng-template>